module.exports = __webpack_public_path__ + "static/img/zn1.387a1fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zn1.png
// module id = a/n/
// module chunks = 17